import { render, staticRenderFns } from "./CABChangeStatis.vue?vue&type=template&id=6312912d&scoped=true&"
import script from "./CABChangeStatis.vue?vue&type=script&lang=js&"
export * from "./CABChangeStatis.vue?vue&type=script&lang=js&"
import style0 from "./CABChangeStatis.vue?vue&type=style&index=0&id=6312912d&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312912d",
  null
  
)

export default component.exports